import { Loader2 } from "lucide-react";

const LoadingState = () => {
  return (
    <div className="rounded-3xl border border-border/60 bg-card py-24 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4 text-primary" />
        <h2 className="text-lg font-medium text-foreground">Loading researcher profile…</h2>
      </div>
    </div>
  );
};

export default LoadingState;
